import { render, staticRenderFns } from "./WebTrainPlanLog.vue?vue&type=template&id=b8f37bd6&scoped=true&"
import script from "./WebTrainPlanLog.vue?vue&type=script&lang=js&"
export * from "./WebTrainPlanLog.vue?vue&type=script&lang=js&"
import style0 from "./WebTrainPlanLog.vue?vue&type=style&index=0&id=b8f37bd6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8f37bd6",
  null
  
)

export default component.exports